import React, { useEffect, useState, Fragment } from "react";
import {
  Card,
  Layout,
  Row,
  Col,
  Button,
  Input,
  Table,
  message,
  Select,
  DatePicker,
  InputNumber,
  Modal,
  Form,
} from "antd";
import "./SPReceiveDo.less";
import { Redirect } from "react-router-dom";
import { url } from "../../config/global";
import Axios from "axios";
import moment from "moment";

const { Content } = Layout;
const { RangePicker } = DatePicker;

const SPReceiveDo = () => {
  const [form] = Form.useForm();

  const [loading, setLoading] = useState(false);
  const [loadingDetail, setLoadingDetail] = useState(false);

  const [expandedRowKeys, setExpandedRowKeys] = useState([]);
  const [expendCell, setExpendCell] = useState("");

  const [listDn, setListDn] = useState([]);
  const [selectedLabelDn, setSelectedLabelDn] = useState(null);

  const [listSj, setListSj] = useState([]);
  const [selectedLabelSj, setSelectedLabelSj] = useState(null);

  const [parameterGet, setParameterGet] = useState({
    dn_no: null,
    sj_no: null,
    start_date: null,
    end_date: null,
  });

  const sortedListSj = [...listSj].sort((a, b) =>
    (a.label ?? "").toLowerCase().localeCompare((b.label ?? "").toLowerCase())
  );

  const sortedListDn = [...listDn].sort((a, b) =>
    (a.label ?? "").toLowerCase().localeCompare((b.label ?? "").toLowerCase())
  );

  const [rangeDate, setRangeDate] = useState([null, null]);

  const [dataSourceOut, setDataSourceOut] = useState([]);
  const [dataSourceOutDetail, setDataSourceOutDetail] = useState([]);

  const [receiveQty, setReceiveQty] = useState({});
  const [receiveNotes, setReceiveNotes] = useState({});

  const [statusReceiving, setStatusReceiving] = useState(false);
  const [suratJalan, setSuratJalan] = useState("");

  useEffect(() => {
  
    
    getDataOutgoing();
  }, [parameterGet]);

  useEffect(() => {
    getDn();
    getSj();
  }, []);

  useEffect(() => {
    if (expendCell) {
      getDataOutgoingDetails(expendCell);
    }
  }, [expendCell]);

  useEffect(() => {
    setExpandedRowKeys([]);
  }, [dataSourceOut]);

  const getDn = () => {
    setLoading(true);
    setListDn([]);
    Axios.get(`${url}/listnodr/receive`, {
      headers: {
        Authorization: `Bearer ${sessionStorage.getItem("token")}`,
      },
    })
      .then((res) => {
        if (res.data.status) {
          const respon = res.data.data.map((item) => ({
            value: item.dn_no,
            label: item.dn_no,
          }));
          setListDn(respon);
        }
      })
      .catch((err) => {
        if (err.response) {
          message.error(err.response.data.message);
          if (err.response.status === 401) {
            sessionStorage.removeItem("token");
          }
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const getSj = () => {
    setLoading(true);
    setListSj([]);
    Axios.get(`${url}/listsj/receive`, {
      headers: {
        Authorization: `Bearer ${sessionStorage.getItem("token")}`,
      },
    })
      .then((res) => {
        if (res.data.status) {
          const respon = res.data.data.map((item) => ({
            value: item.number,
            label: item.number,
          }));
          setListSj(respon);
        }
      })
      .catch((err) => {
        if (err.response) {
          message.error(err.response.data.message);
          if (err.response.status === 401) {
            sessionStorage.removeItem("token");
          }
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const getDataOutgoing = () => {
    const params = new URLSearchParams(window.location.search);
     const no_sj = params.get('no_sj'); 
     if(no_sj != null )
     {
      setSuratJalan(no_sj)
      parameterGet['sj_no'] = no_sj;
     }

    setLoading(true);
    setDataSourceOut([]);
    setDataSourceOutDetail([]);
    setReceiveQty("");
    setReceiveNotes("");
    Axios.get(`${url}/supplier_receive_do`, {
      params: parameterGet,
      headers: {
        Authorization: `Bearer ${sessionStorage.getItem("token")}`,
      },
    })
      .then((res) => {
        setDataSourceOut(res.data);
      })
      .catch((err) => {
        if (err.response) {
          message.error(err.response.data.message);
          if (err.response.status === 401) {
            sessionStorage.removeItem("token");
          }
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const getDataOutgoingDetails = (dn_id = expendCell) => {
    setLoadingDetail(true);
    setDataSourceOutDetail([]);
    Axios.get(`${url}/supplier_receive_do/details/${dn_id}`, {
      headers: {
        Authorization: `Bearer ${sessionStorage.getItem("token")}`,
      },
    })
      .then((res) => {
        if (res.data.status) {
          var count_null_receive = 0;
          const updatedData = res.data.data.map((item) => {
            if (item.receive) {
              item.receive_qty = item.receive.thr_receive_qty;
              item.receive_date = item.receive.thr_date;
              item.receive_notes = item.receive.thr_notes;
            } else {
              item.receive_qty = null;
              item.receive_date = null;
              item.receive_notes = null;
              count_null_receive += 1;
            }
            return item;
          });

          setDataSourceOutDetail(updatedData);
        }
      })
      .catch((err) => {
        if (err.response) {
          message.error(err.response.data.message);
        } else {
          message.error("Backend not yet Started");
        }
      })
      .finally(() => {
        setLoadingDetail(false);
      });
  };

  const handleChangeDn = (value, option) => {
    if (!option) {
      setSelectedLabelDn(null);
      setParameterGet((prev) => ({
        ...prev,
        dn_no: null,
      }));
      return;
    }

    setSelectedLabelDn(option.value);
    setParameterGet((prev) => ({
      ...prev,
      dn_no: option.value,
    }));
    setStatusReceiving(false);
    setSuratJalan("");
  };

  const handleChangeSj = (value, option) => {
    if (!option) {
      setSelectedLabelSj(null);
      setParameterGet((prev) => ({
        ...prev,
        sj_no: null,
      }));
      return;
    }

    setSelectedLabelSj(option.value);
    setParameterGet((prev) => ({
      ...prev,
      sj_no: option.value,
    }));
    setStatusReceiving(false);
    setSuratJalan("");
  };

  const expandedRowRender = (record, index) => {
    var supId = record.supplier_id;
    var supName = record.supplier_name;

    const columnsDetails = [
      {
        title: "Item Number",
        dataIndex: "item_number",
        key: "item_number",
        sorter: true,
        width: 100,
      },
      {
        title: "Description",
        dataIndex: "description_1",
        key: "description_1",
        sorter: true,
        width: 200,
      },      
      {
        title: "Type",
        dataIndex: "model",
        key: "model",
        sorter: true,
        width: 100,
        render: (model) => {
          // Menampilkan elemen pertama dari array 'model' atau gabungkan jika lebih dari satu elemen
          return model && Array.isArray(model) ? model.join(", ") : model;
        },
      },
      {
        title: "Standar Pack",
        dataIndex: "qty_kanban",
        key: "qty_kanban",
        sorter: true,
        width: 50,
      },
      {
        title: "Qty Delivery",
        dataIndex: "qty_delivery",
        key: "qty_delivery",
        sorter: true,
        width: 50,
      },
      {
        title: "Qty Actual",
        dataIndex: "receive_qty",
        key: "receive_qty",
        width: 30,
      },
      {
        title: "Unit",
        dataIndex: "unit_of_measure",
        key: "unit_of_measure",
        sorter: true,
        width: 50,
      },
      {
        title: "Keterangan",
        dataIndex: "receive_notes",
        width: 100,
      },
      {
        title: "Tanggal Receive",
        dataIndex: "receive_date",
        key: "receive_date",
        render: (receive_date) =>
          receive_date !== null
            ? moment(receive_date).format("YYYY-MM-DD")
            : "",
        sorter: true,
        width: 50,
      },
      {
        title: "",
        render: (value, record) => {
          if (record.status_receiving === "completed") {
            return null;
          }

          return (
            <div style={{ display: "flex", gap: 8 }}>
              <Button
                onClick={() =>
                  handleConfirm(index, record, supId, supName, suratJalan)
                }
                type="primary"
                size="small"
                block
              >
                Confirm
              </Button>
            </div>
          );
        },
        sorter: true,
        width: 120,
      },
    ];

    return (
      <Table
        columns={columnsDetails}
        dataSource={dataSourceOutDetail}
        rowKey={(data) => data._id}
        pagination={false}
        size="small"
        loading={loadingDetail}
      />
    );
  };

  const handleReceive = (
    to,
    key,
    record,
    qty,
    notes,
    supplier_id,
    supplier_name,
    wip_no
  ) => {
    if (!qty || qty == null) {
      setLoading(false);
      message.error("Qty tidak boleh di kosongkan!");
    } else {
      setLoading(false);
      if (qty || qty != null) {
        if (qty == record.qty_delivery) {
          if (to == "save") {
            processReceive(
              key,
              record,
              qty,
              notes,
              supplier_id,
              supplier_name,
              wip_no
            );
          } else {
            handleSubmit(record, qty, notes);
          }
        } else {
          if (notes == "" || notes == null) {
            setLoading(false);
            message.error(
              "Qty tidak sesuai dengan Qty Delivery, Wajib menyertakan keterangan jika ingin melanjutkan!"
            );
          } else {
            if (to == "save") {
              processReceive(
                key,
                record,
                qty,
                notes,
                supplier_id,
                supplier_name,
                wip_no
              );
            } else {
              handleSubmit(record, qty, notes);
            }
          }
        }
      } else {
        if (record.receive_qty == record.qty_delivery) {
          if (to == "save") {
            processReceive(
              key,
              record,
              qty,
              notes,
              supplier_id,
              supplier_name,
              wip_no
            );
          } else {
            handleSubmit(record, qty, notes);
          }
        } else {
          if (notes == "" || notes == null) {
            setLoading(false);
            message.error(
              "Qty tidak sesuai dengan Qty Delivery, Wajib menyertakan keterangan jika ingin melanjutkan!"
            );
          } else {
            if (to == "save") {
              processReceive(
                key,
                record,
                qty,
                notes,
                supplier_id,
                supplier_name,
                wip_no
              );
            } else {
              handleSubmit(record, qty, notes);
            }
          }
        }
      }
    }
  };

  const handleConfirm = (index, record, supId, supName, suratJalan) => {
    form.resetFields();
    form.setFieldsValue({
      qtyActual: record.receive_qty,
    });
    form.setFieldsValue({
      keterangan: record.receive_notes,
    });
    Modal.confirm({
      icon: null,
      content: (
        <Form
          form={form}
          layout="horizontal"
          labelCol={{ span: 8 }}
          wrapperCol={{ span: 16 }}
          initialValues={{
            qtyActual: record.receive_qty,
            keterangan: record.receive_notes,
          }}
          colon={false}
        >
          <h3 style={{ textAlign: "center", width: "100%", marginBottom: 10 }}>
            Detail Information Receive
          </h3>
          <Form.Item label="Item Number" style={{ marginBottom: 5 }}>
            <span>{record.item_number}</span>
          </Form.Item>
          <Form.Item label="Description" style={{ marginBottom: 5 }}>
            <span>{record.description_1}</span>
          </Form.Item>
          <Form.Item label="Kanban No" style={{ marginBottom: 5 }}>
            <span>{record.kanban_number}</span>
          </Form.Item>
          <Form.Item label="Type" style={{ marginBottom: 5 }}>
            <span>
              {record.model && Array.isArray(record.model)
                ? record.model.join(", ")
                : record.model}
            </span>
          </Form.Item>
          <Form.Item label="Standar Pack" style={{ marginBottom: 5 }}>
            <span>
              {record.qty_kanban} {record.unit_of_measure}
            </span>
          </Form.Item>
          <Form.Item label="Qty Delivery" style={{ marginBottom: 5 }}>
            <span>
              {record.qty_delivery} {record.unit_of_measure}
            </span>
          </Form.Item>
          <Form.Item label="Tanggal Receive" style={{ marginBottom: 5 }}>
            <span>
              {record.receive_date !== null
                ? moment(record.receive_date).format("YYYY-MM-DD")
                : ""}
            </span>
          </Form.Item>
          <Form.Item
            label="Qty Actual"
            name="qtyActual"
            rules={[
              { required: true, message: "Qty tidak boleh di kosongkan!" },
            ]}
          >
            <InputNumber
              disabled={statusReceiving}
              min={0}
              onChange={(value) => handleQtyChange(index, value)}
            />
          </Form.Item>
          <Form.Item label="Keterangan" name="keterangan">
            <Input.TextArea
              rows={2}
              disabled={statusReceiving}
              onChange={(e) => handleNotesChange(index, e.target.value)}
            />
          </Form.Item>
          <div style={{ textAlign: "right", marginTop: 16 }}>
            <Button
              style={{ marginRight: 8 }}
              onClick={() => {
                Modal.destroyAll();
              }}
            >
              Cancel
            </Button>

            <Button
              type="primary"
              loading={loading}
              disabled={loading}
              style={{ marginRight: 8 }}
              onClick={async () => {
                try {
                  setLoading(true);
                  const qtyActual = form.getFieldValue("qtyActual");
                  const notes = form.getFieldValue("keterangan");

                  handleReceive(
                    "save",
                    index,
                    record,
                    qtyActual !== undefined
                      ? qtyActual
                      : record.receive_qty || null,
                    notes !== undefined ? notes : record.receive_notes || "",
                    supId,
                    supName,
                    suratJalan
                  );
                } catch (err) {
                  message.error(err);
                  setLoading(false);
                }
              }}
            >
              Save Draft
            </Button>
            <Button
              type="primary"
              loading={loading}
              disabled={loading}
              style={{ marginRight: 8 }}
              onClick={async () => {
                try {
                  setLoading(true);
                  const qtyActual = form.getFieldValue("qtyActual");
                  const notes = form.getFieldValue("keterangan");

                  handleReceive(
                    "submit",
                    index,
                    record,
                    qtyActual !== undefined
                      ? qtyActual
                      : record.receive_qty || null,
                    notes !== undefined ? notes : record.receive_notes || "",
                    supId,
                    supName,
                    suratJalan
                  );
                } catch (err) {
                  message.error(err);
                  setLoading(false);
                }
              }}
            >
              Receive
            </Button>
          </div>
        </Form>
      ),
      okButtonProps: { style: { display: "none" } },
      cancelButtonProps: { style: { display: "none" } },
    });
  };

  const handleQtyChange = (key, value) => {
    if (value === "" || value === null) {
      setReceiveNotes((prev) => ({
        ...prev,
        [key]: null,
      }));
    } else {
      setReceiveQty((prev) => ({
        ...prev,
        [key]: value,
      }));
    }
  };

  const handleNotesChange = (key, value) => {
    if (value === "" || value === null) {
      setReceiveNotes((prev) => ({
        ...prev,
        [key]: "",
      }));
    } else {
      setReceiveNotes((prev) => ({
        ...prev,
        [key]: value,
      }));
    }
  };

  const processReceive = (
    key,
    record,
    qty,
    notes,
    supplier_id,
    supplier_name,
    wip_no
  ) => {
    let data = JSON.stringify({
      id: record._id,
      head_id: record.t_histori_outgoing_supplier_id,
      wip_no: wip_no,
      item: record.item_number,
      dn_no: record.dn_no,
      standarpack_qty: record.qty_kanban,
      delivery_qty: record.qty_delivery,
      receive_qty: qty,
      part_number: record.part_number,
      unit: record.unit_of_measure,
      note: notes,
      desc: record.description_1,
      kanban_id: record.kanban_number,
      supplier_id: supplier_id,
      supplier_name: supplier_name,
    });

    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${url}/supplier_receive_do/modify`,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${sessionStorage.getItem("token")}`,
      },
      data: data,
    };
    Axios.request(config)
      .then((response) => {
        var res = response.data;
        if (res.status) {
          message.success(res.message);
          getDataOutgoingDetails(expendCell);
          setReceiveQty("");
          setReceiveNotes("");
        } else {
          message.error(res.message);
        }

        setLoading(false);
        Modal.destroyAll();
      })
      .catch((error) => {
        message.error(error);
        setLoading(false);
        Modal.destroyAll();
      });
  };

  const handleSubmit = (record, qty, notes) => {
    setLoading(true);
    let data = JSON.stringify({
      id: record.t_histori_outgoing_supplier_id,
      data: record,
      qty_actual: qty,
      notes: notes,
    });

    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${url}/supplier_receive_do/save`,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${sessionStorage.getItem("token")}`,
      },
      data: data,
    };
    Axios.request(config)
      .then((response) => {
        var res = response.data;
        if (res.status) {
          message.success(res.message);
          if (res.completed) {
            setSelectedLabelDn(null);
            setSelectedLabelSj(null);

            setParameterGet((prev) => ({
              ...prev,
              dn_no: null,
              sj_no: null,
            }));

            getDn();
            getSj();
          } else {
            getDn();
            getDataOutgoingDetails(expendCell);
            getSj();
          }
        } else {
          message.error(res.message);
        }

        Modal.destroyAll();
        setLoading(false);
      })
      .catch((error) => {
        message.error(error.response.data.message);
        setLoading(false);

        Modal.destroyAll();
      });
  };

  const handleRangeChange = (rangeDate) => {
    if (!rangeDate) {
      setRangeDate(null);
      setParameterGet((prev) => ({
        ...prev,
        start_date: null,
        end_date: null,
      }));
    } else {
      setRangeDate(rangeDate);
      setParameterGet((prev) => ({
        ...prev,
        start_date: rangeDate[0].format("YYYY-MM-DD"),
        end_date: rangeDate[1].format("YYYY-MM-DD"),
      }));
    }
  };

  const handleClickDetails = (data) => {
    const index = data[data.length - 1];

    setExpandedRowKeys([index]);
    if (index) {
      const selectedRecord = dataSourceOut.data.find(
        (item) => item._id === index
      );
      setSuratJalan(selectedRecord.number);
      setExpendCell(index);
      getDataOutgoingDetails(index);
    }
  };

  const defaultColumns = [
    {
      title: "DN NO",
      dataIndex: "dn_no",
      sorter: true,
    },
    {
      title: "Surat Jalan",
      dataIndex: "number",
      sorter: true,
    },
    {
      title: "No PO",
      dataIndex: "po_number",
      sorter: true,
    },
    {
      title: "Supplier",
      dataIndex: "supplier_name",
      sorter: true,
    },
    {
      title: "No Kendaraan",
      dataIndex: "vehicle_number",
      sorter: true,
    },
    {
      title: "Tanggal Outgoing",
      dataIndex: "created_at",
      render: (created_at) => moment(created_at).format("YYYY-MM-DD"),
      sorter: true,
    },

    {
      title: "Created By",
      sorter: true,
      dataIndex: "created_by",
    },
  ];

  const columns = defaultColumns.map((col) => {
    if (!col.editable) {
      return col;
    }
    return {
      ...col,
      onCell: (record) => ({
        record,
        editable: col.editable,
        dataIndex: col.dataIndex,
        title: col.title,
      }),
    };
  });

  if (!sessionStorage.getItem("token")) {
    return <Redirect to="/login" />;
  }

  return (
    <Fragment>
      <Row>
        <Col xs={24}>
          <Card
            type="inner"
            title="Receive DO"
            extra={moment(new Date()).format("DD MMMM YYYY")}
          ></Card>
        </Col>
      </Row>

      <Content className="content">
        <Row>
          <Col xs={24}>
            <Card className="body-data">
              <Row gutter={[10, 20]}>
                <Col xs={6} md={6} lg={6}>
                  <Select
                    showSearch
                    style={{
                      width: 220,
                    }}
                    placeholder="Search DN"
                    onChange={handleChangeDn}
                    optionFilterProp="label"
                    options={sortedListDn}
                    value={selectedLabelDn || undefined}
                    allowClear
                  />
                </Col>

                <Col xs={6} md={6} lg={6}>
                  <Select
                    showSearch
                    style={{
                      width: 220,
                    }}
                    placeholder="Search Surat Jalan"
                    onChange={handleChangeSj}
                    optionFilterProp="label"
                    options={sortedListSj}
                    value={selectedLabelSj || undefined}
                    allowClear
                  />
                </Col>
                <Col xs={6} md={6} lg={6}>
                  <RangePicker
                    value={rangeDate}
                    onChange={handleRangeChange}
                    format="YYYY-MM-DD"
                    allowClear
                  />
                </Col>
              </Row>
              <Row type="flex" gutter={[10, 20]} justify="space-around">
                <Col xs={24}>
                  <Table
                    scroll={{ x: 1300 }}
                    loading={loading}
                    rowClassName="editable-row"
                    bordered
                    dataSource={dataSourceOut.data}
                    rowKey={(data) => data._id}
                    columns={columns}
                    expandable={{
                      expandedRowRender: expandedRowRender,
                      expandedRowKeys: expandedRowKeys,
                      onExpandedRowsChange: (data) => handleClickDetails(data),
                    }}
                  />
                </Col>
              </Row>
            </Card>
          </Col>
        </Row>
      </Content>
    </Fragment>
  );
};

export default SPReceiveDo;
